import { LineChart, Sparkles, Target } from "lucide-react";

const pillars = [
    {
        icon: Target,
        title: "Strategic Selection",
        desc: "We pick the right project. Where market demand actually is.",
    },
    {
        icon: Sparkles,
        title: "Creative Precision",
        desc: "Scriptwriting to final grade. No corners cut, ever.",
    },
    {
        icon: LineChart,
        title: "Continuous Optimization",
        desc: "A/B testing, retargeting, real-time optimisation.",
    },
];

export default function Approach() {
    return (
        <section id="approach" className="relative py-24 sm:py-32 border-t border-white/10 bg-[#0d0d0f]">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="mb-16">
                    <div className="eyebrow mb-4 flex items-center gap-3">
                        <span className="inline-block w-10 h-[2px] bg-brand" /> Our approach
                    </div>
                    <h2 className="font-display font-medium tracking-[-0.04em] text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.02] max-w-4xl">
                        Marketing built on <span className="text-brand">analysis</span>,<br />
                        not <span className="text-white/40">guesswork.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
                    {pillars.map((p) => {
                        const Icon = p.icon;
                        return (
                            <div
                                key={p.title}
                                className="relative bg-[#141414] border border-white/10 p-8 sm:p-10 group hover:border-brand/50 transition-colors"
                            >
                                <Icon className="w-7 h-7 text-brand mb-6" />
                                <h3 className="font-display font-medium text-2xl text-white leading-tight tracking-[-0.02em]">{p.title}</h3>
                                <p className="mt-3 text-white/60 leading-relaxed">{p.desc}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
